import { render, staticRenderFns } from "./AsciiFish.vue?vue&type=template&id=3a948cc4"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a948cc4')) {
      api.createRecord('3a948cc4', component.options)
    } else {
      api.reload('3a948cc4', component.options)
    }
    module.hot.accept("./AsciiFish.vue?vue&type=template&id=3a948cc4", function () {
      api.rerender('3a948cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/brightfish/stargate-client/resources/js/components/AsciiFish.vue"
export default component.exports